import { render, staticRenderFns } from "./CareList.vue?vue&type=template&id=0bad6618&scoped=true"
import script from "./CareList.vue?vue&type=script&lang=js"
export * from "./CareList.vue?vue&type=script&lang=js"
import style0 from "./CareList.vue?vue&type=style&index=0&id=0bad6618&prod&lang=less&scoped=true"
import style1 from "./CareList.vue?vue&type=style&index=1&id=0bad6618&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bad6618",
  null
  
)

export default component.exports